import React, { FC, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Vessel as SeagoingVessel } from '@sdir/httpclient/lib/clients/aps/seagoing';
import { SdirModal } from '@sdir/sds';
import { Form, Formik } from 'formik';
import { Country } from '@sdir/httpclient/lib/clients/core/search';
import { useIntl } from 'react-intl';
import { createInitialVesselInput, VesselSubForm } from '../VesselSubForm';
import { AddedSeagoing, SelectOption, VesselSubformInput } from '../../../../../types';
import { formatCountryOptions } from '../../../../../helpers/formattingHelpers';

type EditVesselInput = {
  editvessel: VesselSubformInput;
};

type EditVesselModalProps = {
  isOpen: boolean;
  countries: Country[];
  onClose: () => void;
  seagoing: AddedSeagoing;
  onConfirm: (vessel: SeagoingVessel) => void;
};

export const EditVesselModal: FC<EditVesselModalProps> = ({
  isOpen,
  countries,
  seagoing,
  onClose,
  onConfirm,
}) => {
  const intl = useIntl();

  const initialValues = () => {
    const initial = {
      editvessel: createInitialVesselInput(),
    };
    initial.editvessel.existingVessel = seagoing.vessel;
    return initial;
  };

  const countryOptions = useMemo(() => {
    return formatCountryOptions(countries);
  }, [countries]);

  const handleSubmit = useCallback(
    (values: EditVesselInput) => {
      const vesselNewDetail = values.editvessel.useExisting
        ? values.editvessel.existingVessel
        : values.editvessel.newVessel;
      if (!vesselNewDetail) return;
      onConfirm(vesselNewDetail);
    },
    [onConfirm]
  );

  return (
    <Formik initialValues={initialValues()} onSubmit={handleSubmit}>
      {({ submitForm }) => (
        <StyledModal
          visible={isOpen}
          onCancel={onClose}
          onOK={submitForm}
          cancelText={intl.formatMessage({ id: 'general.form.cancel' })}
          okText={intl.formatMessage({ id: 'general.form.save' })}
        >
          <Form>
            <VesselSubForm name="editvessel" countryOptions={countryOptions} />
          </Form>
        </StyledModal>
      )}
    </Formik>
  );
};

const StyledModal = styled(SdirModal)`
  font-size: 16px;
`;
